import { Injectable } from '@angular/core';
import { DomainType, DomainUrl } from '../common/enums/app-domain.enum';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DomainManagerService {
    private readonly _domainType: DomainType;
    private readonly hostname: string = window.location.hostname;

    constructor() {
        this._domainType = this.determineDomainType();
    }

    private determineDomainType(): DomainType {
        const host = this.hostname.toLowerCase();

        // Check for specific product keywords in the hostname
        if (host.includes('plusradiology') || environment.environmentType === 'plusradiology') {
            return DomainType.Radiology;
        }

        if (host.includes('plusdoctor') || environment.environmentType === 'plusdoctor') {
            return DomainType.Doctor;
        }

        if (host.includes('pluspedia') || environment.environmentType === 'pluspediatric') {
            return DomainType.Pediatric;
        }

        if (host.includes('plusgynecologist') || environment.environmentType === 'plusgynecologist') {
            return DomainType.Gynecologist;
        }

        // Default or Physio
        return DomainType.Physio;
    }

    public get domainType(): DomainType {
        return this._domainType;
    }

    public get isRadiologyDomain(): boolean {
        return this._domainType === DomainType.Radiology;
    }

    public get isDoctorDomain(): boolean {
        return this._domainType === DomainType.Doctor;
    }

    public get isPhysioDomain(): boolean {
        return this._domainType === DomainType.Physio;
    }

    public get isPediatricDomain(): boolean {
        return this._domainType === DomainType.Pediatric;
    }

    public get isGynecologistDomain(): boolean {
        return this._domainType === DomainType.Gynecologist;
    }

    public getLogoUrl(): string {
        switch (this._domainType) {
            case DomainType.Radiology:
                return '/assets/image/Plus-Radiology.png';
            case DomainType.Doctor:
                return '/assets/image/Plus-Doctor-logo.png';
            case DomainType.Pediatric:
                return '/assets/image/plus_pedia_logo.png';
            case DomainType.Gynecologist:
                return '/assets/image/plus_gynecologist_logo.png';
            case DomainType.Physio:
            default:
                return '/assets/image/logo.jpg';
        }
    }

    public get isTestDomain(): boolean {
        return this.hostname.includes(DomainUrl.Localhost) || this.hostname.includes(DomainUrl.IfourConsultancy);
    }
}
